import { render } from "./PageWrapper.vue?vue&type=template&id=4db7eeb3"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"

import "./PageWrapper.vue?vue&type=style&index=0&id=4db7eeb3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/PageWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4db7eeb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4db7eeb3', __exports__)) {
    api.reload('4db7eeb3', __exports__)
  }
  
  module.hot.accept("./PageWrapper.vue?vue&type=template&id=4db7eeb3", () => {
    api.rerender('4db7eeb3', render)
  })

}


export default __exports__